import { draftDataActionType } from './draftDataActionType';

const { DRAFTEDDATA } = draftDataActionType;

export const darftedData = (darfteddata) => {
	return {
		type: DRAFTEDDATA,
		payload: darfteddata,
	};
};
